import EmailSubscriptionService from '@99designs/common/utils/platform/emailSubscriptionService';
// tslint:disable-next-line:import-blacklist
import $ from 'jquery';

export default function() {
    $('[data-email-collector]').each(function() {
        initCollector(this);
    });
}

interface FormData {
    [key: string]: string;
}

type FormDataKeyValPair = [string, string];

function initCollector(parentObject: HTMLElement) {
    $(parentObject)
        .find('[data-email-collector-form]')
        .submit(function(e) {
            e.preventDefault();

            const genericError = $(parentObject).find('[data-email-collector-error-translated]');
            const formData: FormData = $(this)
                .serializeArray()
                .reduce(function(obj: { [key: string]: string }, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});

            const service = new EmailSubscriptionService();

            service
                .subscribe({
                    email: formData['email_subscription[email_address]'],
                    acquisitionSource: formData['email_subscription[acquisition_source]'],
                    subscribeToMarketing: Boolean(
                        formData['email_subscription[subscribe_to_marketing]']
                    ),
                    customData: {
                        ...getCustomDataFields(formData),
                        is_designer: formData['email_subscription[custom_data][is_designer]'],
                        industry: formData['industry'],
                        alternative_acquisition_source:
                            formData[
                                'email_subscription[custom_data][alternative_acquisition_source]'
                            ],
                    },
                })
                .then(res => {
                    handleSuccess(res, parentObject);
                })
                .catch(res => {
                    const errorMessages = res.errors || genericError;
                    handleError(errorMessages, parentObject);
                });
        });
}

function handleSuccess(post: any, parentObject: HTMLElement) {
    const collector = $(parentObject).find('[data-email-collector-collect]'),
        collectorError = $(parentObject).find('[data-email-collector-error]'),
        collectorSent = $(parentObject).find('[data-email-collector-sent]');

    // Hide existing error on post
    collector.attr('data-hidden', 'true');

    // Hide collector, show sent message
    collectorSent.removeAttr('data-hidden');
    collectorError.attr('data-hidden', 'true');
}

function handleError(errors: any, parentObject: HTMLElement) {
    const collectorWidth =
            $(parentObject)
                .find('[data-email-collector-collect-fields]')
                .width() + 'px',
        collectorError = $(parentObject).find('[data-email-collector-error]'),
        collectorErrorField = $(parentObject).find('[data-email-collector-error-field]');

    collectorErrorField.html(Array(errors).join('<br>'));
    collectorError.css({ width: collectorWidth }).removeAttr('data-hidden');
}

function getCustomDataFields(formData: FormData): FormData {
    return Object.entries(formData)
        .filter(([key, _]: FormDataKeyValPair) => key.includes('email_subscription[custom_data]'))
        .map(([key, val]: FormDataKeyValPair) => {
            return [customDataFieldBaseName(key), val];
        })
        .reduce((obj: FormData, [key, val]: FormDataKeyValPair) => {
            obj[key] = val;
            return obj;
        }, {});
}

function customDataFieldBaseName(key: string): string {
    const regex = new RegExp(/email_subscription\[custom_data\]\[(.*)\]/);
    const match = key.match(regex);
    if (match) {
        return match[1];
    }
    return key;
}
